import { convertToSnakeCase } from 'vio-libs';

export const isBackboneFiber = (name: string): boolean => (name.toLowerCase().indexOf('backbone') > -1);

export const convertToFiberName = (name: string): string => (convertToSnakeCase(name).toLowerCase().replace(/_/g, ''));

export const getFiberColor = (future: boolean): string => (future ? '#d9d9d9' : '#00c5dc');

export { getOrphanedLayerTableRows, getSourceTableRows } from './tableRows';

export {
	get,
	patch,
	post,
	put,
	remove
} from './request/lib';
